export const FRENCH_LANGUAGE: any = {
  flag: "🇫🇷",
  label: "français",
  code: "fr",
  header: {
    aboutMe: "Qui suis-je?",
    skills: "Compétences",
    experiences: "Expériences",
    projects: "Projets",
    contact: "Contact",
    review: "Revue",
    download: "Télécharger mon CV",
  },

  contact: {
    thanks: "Merci de votre visite !",
    msg: ["Donnez votre avis", "ici."],
    joinMe: "Rejoignez-moi sur",
  },

  footer: {
    copyright: `Copyright© 2017-${new Date().getFullYear()} Brillant. Tous droits réservés.`,
    language: "Langage",
  },
};
